import { createContext } from 'react';
import type { CleOption, EtatAccessibilite } from './options';

export interface ContexteAccessibilite {
  etat: EtatAccessibilite;
  basculer: (cle: CleOption) => void;
  reinitialiser: () => void;
  /** Nombre d'adaptations actives, affiché sur le bouton flottant. */
  nombreActives: number;
  /** La lecture vocale n'existe pas dans tous les navigateurs. */
  lectureVocaleDisponible: boolean;
  /** Panneau du bouton flottant, ouvert aussi depuis l'écran « Accessibilité ». */
  panneauOuvert: boolean;
  ouvrirPanneau: () => void;
  fermerPanneau: () => void;
}

export const ContexteA11y = createContext<ContexteAccessibilite | null>(null);
